import React from 'react';
import PropTypes from 'prop-types';

export default function HeightIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" {...rest}>
      <path
        fill={color}
        d="M6.66666667,19.2036343 C6.66666667,19.643455 6.28913641,20 5.83580822,20 L0.830858449,20 C0.371987998,20 0,19.6357897 0,19.2036343 L0,0.796365626 C0,0.356545036 0.377530257,0 0.830858449,0 L19.1639999,0 C19.62571,0 20,0.377530257 20,0.830858449 L20,5.83580822 C20,6.29467867 19.6294743,6.66666667 19.1659402,6.66666667 L6.66666667,6.66666667 L6.66666667,19.2036343 Z M5.83333333,0.833333333 L0.833333333,0.833333333 L0.833333333,19.1666667 L5.83333333,19.1666667 L5.833,16.666 L2.5,16.6666667 L2.5,15.8333333 L5.833,15.833 L5.833,14.166 L4.16666667,14.1666667 L4.16666667,13.3333333 L5.833,13.333 L5.833,11.666 L2.5,11.6666667 L2.5,10.8333333 L5.833,10.833 L5.833,9.166 L4.16666667,9.16666667 L4.16666667,8.33333333 L5.833,8.333 L5.833,6.666 L2.5,6.66666667 L2.5,5.83333333 L5.833,5.833 L5.833,4.166 L4.16666667,4.16666667 L4.16666667,3.33333333 L5.833,3.333 L5.83333333,0.833333333 Z M19.1666667,0.833333333 L6.66666667,0.833333333 L6.66666667,5.83333333 L8.333,5.833 L8.33333333,4.16666667 L9.16666667,4.16666667 L9.166,5.833 L10.833,5.833 L10.8333333,2.5 L11.6666667,2.5 L11.666,5.833 L13.333,5.833 L13.3333333,4.16666667 L14.1666667,4.16666667 L14.166,5.833 L15.833,5.833 L15.8333333,2.5 L16.6666667,2.5 L16.666,5.833 L19.1666667,5.83333333 L19.1666667,0.833333333 Z"
      />
    </svg>
  );
}

HeightIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

HeightIcon.defaultProps = {
  size: 20,
  color: '#000',
};
